import { createAction, props } from '@ngrx/store';
import { IProjectType } from '@app/models/project-type.model';
import { IField } from '@app/models/field.model';
import { FieldEntityType } from '@app/models/FieldEntityType';

enum ActionTypes {
    GetProjectTypes = '[PROJECT TYPES] Get Project Types',
    ProjectTypesLoaded = '[PROJECT TYPES] Load success',
    ErrorProjectTypes = '[PROJECT TYPES] Error',
    BeginCreateProjectType = '[PROJECT TYPE] Begin create project type',
    SuccessCreateProjectType = '[PROJECT TYPES] Success create project type',
    BeginUpdateProjectType = '[PROJECT TYPE] Begin update project type',
    SuccessUpdateProjectType = '[PROJECT TYPES] Success update project type',
    BeginRemoveProjectType = '[PROJECT TYPE] Begin remove project type',
    SuccessRemoveProjectType = '[PROJECT TYPES] Success remove project type',
    BeginAddSection = '[PROJECT TYPES] Begin add section',
    SuccessAddSection = '[PROJECT TYPES] Success add section',
    BeginMoveFieldToSection = '[PROJECT TYPES] Begin move field to section',
    SuccessMoveFieldToSection = '[PROJECT TYPES] Success move field to section',
    BeginFetchSelectedProjectType = '[PROJECT TYPE] Begin fetch selected project type',
    SuccessFetchSelectedProjectType = '[PROJECT TYPE] Success fetch selected project type',
    BeginConnectFieldToProjectType = '[PROJECT TYPE] Begin connect field to project type',
    SuccessConnectFieldToProjectType = '[PROJECT TYPE] Success connect field to project type',
    BeginChangeSectionName = '[PROJECT TYPE] Begin change section name',
    SuccessChangeSectionName = '[PROJECT TYPE] Success change section name',
    BeginMoveSection = '[PROJECT TYPE] Begin move section',
    SuccessMoveSetion = '[PROJECT TYPE] Success move section',
}

export const GetProjectTypesAction = createAction(
    ActionTypes.GetProjectTypes
);

export const ProjectTypesLoadedAction = createAction(
    ActionTypes.ProjectTypesLoaded,
    props<{ payload }>()
);

export const ErrorProjectTypesAction = createAction(
    ActionTypes.ErrorProjectTypes, props<Error>()
);

export const BeginCreateProjectTypeAction = createAction(
    ActionTypes.BeginCreateProjectType,
    props<{ payload: IProjectType }>()
);

export const SuccessCreateProjectTypeAction = createAction(
    ActionTypes.SuccessCreateProjectType,
    props<{ payload }>()
);

export const BeginUpdateProjectTypeAction = createAction(
    ActionTypes.BeginUpdateProjectType,
    props<{ payload: IProjectType }>()
);

export const SuccessUpdateProjectTypeAction = createAction(
    ActionTypes.SuccessUpdateProjectType,
    props<{ payload }>()
);

export const BeginRemoveProjectTypeAction = createAction(
  ActionTypes.BeginRemoveProjectType,
  props<{ payload: IProjectType }>()
);

export const SuccessRemoveProjectTypeAction = createAction(
  ActionTypes.SuccessRemoveProjectType,
  props<{ payload }>()
);
export const BeginFetchSelectedProjectTypeAction = createAction(
    ActionTypes.BeginFetchSelectedProjectType,
    props<{ payload: {typeId: string} }>()
);

export const SuccessFetchSelectedProjectTypeAction = createAction(
    ActionTypes.SuccessFetchSelectedProjectType,
    props<{ payload: IProjectType }>()
);

export const BeginAddSectionAction = createAction(
    ActionTypes.BeginAddSection,
    props<{ payload: {projectTypeId: string, entityType: FieldEntityType} }>()
);

export const SuccessAddSectionAction = createAction(
    ActionTypes.SuccessAddSection,
    props<{ payload: IProjectType }>()
);

export const BeginMoveFieldToSectionAction = createAction(
    ActionTypes.BeginMoveFieldToSection,
    props<{ payload: {projectTypeId: string, fieldId: string, currentSectionId: string, previousSectionId: string, targetIndex: number, previousIndex } }>()
);

export const SuccessMoveFieldToSectionAction = createAction(
    ActionTypes.SuccessMoveFieldToSection,
    props<{ payload: IProjectType }>()
);

export const BeginConnectFieldToProjectTypeAction = createAction(
    ActionTypes.BeginConnectFieldToProjectType,
    props<{ payload: { projectTypeId: string, fields: IField[], entityType: FieldEntityType } }>()
);

export const SuccessConnectFieldToProjectTypeAction = createAction(
    ActionTypes.SuccessConnectFieldToProjectType,
    props<{ payload: { projectType: IProjectType } }>()
);

export const BeginChangeSectionNameAction = createAction(
    ActionTypes.BeginChangeSectionName,
    props<{ payload: { projectTypeId: string, sectionId: string, name: string } }>()
);

export const SuccessChangeSctionNameAction = createAction(
    ActionTypes.SuccessChangeSectionName,
    props<{ payload: { projectType: IProjectType } }>()
);

export const BeginMoveSectionAction = createAction(
    ActionTypes.BeginMoveSection,
    props<{ payload: { projectTypeId: string, sectionId: string, targetIndex: number } }>()
);

export const SuccessMoveSectionAction = createAction(
    ActionTypes.SuccessMoveSetion,
    props<{ payload: { projectType: IProjectType } }>()
);
